import { LanguageSelector } from "@cadenza/i18n-ui";
import { ThemePaletteSelector } from "@cadenza/theme";
import { Settings } from "@cadenza/settings";

// Each entry can optionally include `props`
export const rightControls = [
  {
    key: "theme",
    Component: ThemePaletteSelector,
    props: { menuListClassName: "dropdown-up" },
  },
  {
    key: "language",
    Component: LanguageSelector,
    props: { menuListClassName: "dropdown-up" },
  },
  {
    key: "settings",
    Component: Settings,
    props: { menuListClassName: "dropdown-up" },
  },
];
